export const EnumRegistry = {};
